import { Reveal, Overline } from "@/components/Reveal";
import { TEAM } from "@/data/content";

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="bg-[#FBF9F5] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="text-center max-w-2xl mx-auto mb-14 md:mb-18">
          <Overline>Leadership</Overline>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.9rem] tracking-tight text-[#0B192C] leading-tight">
            Meet Our Team
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {TEAM.map((member, i) => (
            <Reveal key={member.name} delay={0.12 * i} y={36}>
              <div
                data-testid={`team-card-${i}`}
                className="group bg-white rounded-2xl border border-[#E2E8F0]/80 overflow-hidden text-center transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_-22px_rgba(11,25,44,0.2)] hover:border-[#C5A059]/40"
              >
                <div className="relative bg-gradient-to-b from-[#E4EFF8] to-[#F4EFE6] px-8 pt-10 pb-16">
                  <div
                    data-testid={`team-photo-${i}`}
                    className="mx-auto w-full max-w-[240px] aspect-[3/4] rounded-2xl overflow-hidden border-2 border-[#C5A059]/60 shadow-[0_16px_36px_-16px_rgba(11,25,44,0.3)]"
                  >
                    <img
                      src={member.image}
                      alt={`${member.name}, ${member.role} of Trivena Exim LLP`}
                      loading="lazy"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
                <div className="relative px-8 pb-9 -mt-7">
                  <div className="bg-white rounded-xl border border-[#E2E8F0] px-6 py-5 shadow-sm">
                    <h3 className="font-serif text-2xl text-[#0B192C] tracking-tight">
                      {member.name}
                    </h3>
                    <p className="mt-1.5 text-xs uppercase tracking-[0.24em] font-semibold text-[#B38C44]">
                      {member.role}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
